// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFileUrlsResponseDto } from './IFileUrlsResponseDto';
import {
    IFileUrlsResponseDtoFromJSON,
    IFileUrlsResponseDtoFromJSONTyped,
    IFileUrlsResponseDtoToJSON,
    IFileUrlsResponseDtoToJSONTyped,
} from './IFileUrlsResponseDto';

/**
 * 
 * @export
 * @interface IDocumentFilesUrlDto
 */
export interface IDocumentFilesUrlDto {
    /**
     * 
     * @type {number}
     * @memberof IDocumentFilesUrlDto
     */
    document_id?: number;
    /**
     * 
     * @type {Array<IFileUrlsResponseDto>}
     * @memberof IDocumentFilesUrlDto
     */
    files?: Array<IFileUrlsResponseDto>;
}

/**
 * Check if a given object implements the IDocumentFilesUrlDto interface.
 */
export function instanceOfIDocumentFilesUrlDto(value: object): value is IDocumentFilesUrlDto {
    return true;
}

export function IDocumentFilesUrlDtoFromJSON(json: any): IDocumentFilesUrlDto {
    return IDocumentFilesUrlDtoFromJSONTyped(json, false);
}

export function IDocumentFilesUrlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentFilesUrlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(IFileUrlsResponseDtoFromJSON)),
    };
}

export function IDocumentFilesUrlDtoToJSON(json: any): IDocumentFilesUrlDto {
    return IDocumentFilesUrlDtoToJSONTyped(json, false);
}

export function IDocumentFilesUrlDtoToJSONTyped(value?: IDocumentFilesUrlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(IFileUrlsResponseDtoToJSON)),
    };
}

